// extracted by mini-css-extract-plugin
export default {"numberInputMantine":"NumberInput_numberInputMantine__+vEbl"};